import { render, staticRenderFns } from "./AbaEditarDadosProgramacao.vue?vue&type=template&id=4448801e"
import script from "./AbaEditarDadosProgramacao.vue?vue&type=script&lang=ts"
export * from "./AbaEditarDadosProgramacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports